export default __webpack_public_path__ + "static/media/qr_chplay_okara.b5d1c8bf.svg";